export default __webpack_public_path__ + "static/media/remove-x.a971c0c6.svg";